import {Component, Input, OnDestroy} from '@angular/core';
import {ThemePalette} from '@angular/material/core';

export const SpinnerTemplate = `
  <div [hidden]="!visible"
        [ngClass]="baseClass">
      <div
        *ngFor="let item of items; let i = index"
        [ngClass]="getClasses(i)"
        [style.backgroundColor]="colorHex">
      </div>
  </div>
`;

@Component({
    selector: 'spinner',
    template: SpinnerTemplate
})
export class SpinnerComponent implements OnDestroy {
    public visible: boolean = true;
    public timeout: any;
    public baseClass: string = 'chasing-dots-spinner';
    public childClass: string = 'dot';
    public numItems: number = 2;

    @Input() public delay: number = 0;
    @Input() public size: number = 40;
    @Input() public color: ThemePalette | ThemePalette[] = 'primary';
    @Input() public colorHex: string = null;

    @Input()
    public set isRunning(value: boolean) {
        if (!value) {
            this.cancel();
            this.visible = false;
            return;
        }

        if (this.timeout) {
            return;
        }

        this.timeout = setTimeout(() => {
            this.visible = true;
            this.cancel();
        }, this.delay);
    }

    public getClasses(i: number = 0) {
        let classes = '';
        if (this.childClass) {
            classes += (this.childClass + (i + 1));
        }

        let color = 'primary';
        if (Array.isArray(this.color)) {
            if (this.color.length >= (i + 1)) {
                color = this.color[i];
            }
        } else if (typeof this.color === 'string') {
            color = this.color;
        }

        switch (color) {
            case 'primary':
                classes += ' mat-primary-bg';
                break;
            case 'accent':
                classes += ' mat-accent-bg';
                break;
            case 'warn':
                classes += ' mat-warn-bg';
                break;
        }
        return classes;
    }

    private cancel(): void {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }

    public get items() {
        return Array(this.numItems);
    }

    ngOnDestroy(): any {
        this.cancel();

    }
}
